var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SkeletonPage, Layout, SkeletonBodyText, List, TextContainer, SkeletonDisplayText, Page, Badge, LegacyCard, Card, BlockStack, Text, TextField, Select, Link, FooterHelp } from '@shopify/polaris';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { createApp } from '@shopify/app-bridge';
;
var notificationOptions = [
    {
        id: 'orderUpdates',
        name: 'Order updates',
        description: 'Receive notifications for new and updated orders.',
    },
    {
        id: 'lowStockAlerts',
        name: 'Low stock alerts',
        description: 'Get notified when product stock is running low.',
    },
    {
        id: 'outOfStockAlerts',
        name: 'Out of stock alerts',
        description: 'Be alerted when products go out of stock.',
    },
    {
        id: 'dailySummary',
        name: 'Daily summary reports',
        description: 'Receive a daily summary of orders and stock status.',
    },
];
var Dashboard = function () {
    var _a = useState({
        is_loading: true,
        shop: '',
        access_key: '',
        code: '',
        slack_name: '',
        slack_channels: [],
        slack_channel_options: [],
        slack_notifications: [],
        load_shopify_admin: false
    }), data = _a[0], setData = _a[1];
    var _b = useState(null), timeoutId = _b[0], setTimeoutId = _b[1];
    var navigate = useNavigate();
    useEffect(function () {
        var _a;
        var urlParams = new URLSearchParams(window.location.search);
        var shop = urlParams.get('shop') || '';
        var is_loading = (shop != '' ? true : false);
        var access_key = ((_a = urlParams.get('access_key')) !== null && _a !== void 0 ? _a : (shop ? Cookies.get("access_key_".concat(shop)) || '' : ''));
        var code = urlParams.get('code') || '';
        //Reset the cookie if not blank
        if (access_key != '') {
            Cookies.set("access_key_".concat(shop), access_key, {
                secure: true, // Only over HTTPS
                sameSite: 'None', // Supports cross-origin iframe contexts
                path: '/', // Available site-wide
            });
        }
        if (access_key == '') {
            if (data.shop == '')
                navigate("/");
            else
                navigate("/?shop=".concat(encodeURIComponent(data.shop)));
        }
        // Set state with extracted values
        setData(function (prevData) { return (__assign(__assign({}, prevData), { is_loading: is_loading, shop: shop, access_key: access_key, code: code })); });
    }, []);
    useEffect(function () {
        var _a;
        if (data.code != '') {
            handleCompleteConnectSlack();
        }
        else if (data.load_shopify_admin && window.self === window.top) {
            handleLoadInsideShopify();
        }
        else if (data.access_key != '' && data.is_loading) {
            //handleFetchConfig();
            setData(function (prevData) { return (__assign(__assign({}, prevData), { is_loading: false, load_shopify_admin: true })); });
        }
        else if (new URLSearchParams(location.search).get('host') != undefined) {
            var app = createApp({
                apiKey: App.shopify_api_key,
                host: (_a = new URLSearchParams(window.location.search).get('host')) !== null && _a !== void 0 ? _a : '',
            });
        }
    }, [data]);
    var handleLoadInsideShopify = function () { return __awaiter(void 0, void 0, void 0, function () {
        var redirectUrl;
        return __generator(this, function (_a) {
            redirectUrl = "https://".concat(data.shop, "/admin/apps/").concat(App.shopify_api_key, "/dashboard?access_key=").concat(data.access_key);
            window.location.href = redirectUrl;
            return [2 /*return*/];
        });
    }); };
    var handleInitSlack = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // Add your installation logic here
            fetch(App.api_base + '/init_slack_connect', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Vuedoo-Domain': App.domain,
                    'X-Vuedoo-Access-Key': data.access_key
                },
                body: JSON.stringify({})
            })
                .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse JSON response
            })
                .then(function (res) {
                if (res.status === 'success') {
                    var redirectUrl = res.url + '&redirect_uri=' + encodeURIComponent(App.base + '/dashboard/?shop=' + data.shop);
                    if (window.top != null)
                        window.top.location.href = redirectUrl;
                    else
                        window.location.href = redirectUrl;
                }
            })
                .catch(function (error) {
                console.error('Error:', error);
            });
            return [2 /*return*/];
        });
    }); };
    var handleCompleteConnectSlack = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // Add your installation logic here
            fetch(App.api_base + '/slack_validate_code', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Vuedoo-Domain': App.domain,
                    'X-Vuedoo-Access-Key': data.access_key
                },
                body: JSON.stringify({ code: data.code, redirect_uri: App.base + '/dashboard/?shop=' + data.shop })
            })
                .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse JSON response
            })
                .then(function (res) {
                if (res.status === 'success') {
                    window.location.assign(App.base + '/dashboard?shop=' + data.shop);
                }
            })
                .catch(function (error) {
                console.error('Error:', error);
            });
            return [2 /*return*/];
        });
    }); };
    var handleFetchConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // Add your installation logic here
            fetch(App.api_base + '/get_config', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Vuedoo-Domain': App.domain,
                    'X-Vuedoo-Access-Key': data.access_key
                },
                body: JSON.stringify({})
            })
                .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse JSON response
            })
                .then(function (res) {
                if (res.status === 'success') {
                    var slack_channel_options_1 = __spreadArray([
                        { label: 'Do not notify', value: '' }
                    ], res.slack_channels.map(function (channel) { return ({
                        label: channel.name,
                        value: channel.id,
                    }); }), true);
                    var slack_notifications_1 = checkAndSetDefaultNotification(res.notifications);
                    setData(function (prevData) { return (__assign(__assign({}, prevData), { is_loading: false, slack_name: res.slack_name, slack_channels: res.slack_channels, slack_channel_options: slack_channel_options_1, slack_notifications: slack_notifications_1, load_shopify_admin: true })); });
                }
                else {
                    setData(function (prevData) { return (__assign(__assign({}, prevData), { is_loading: false, load_shopify_admin: true })); });
                }
            })
                .catch(function (error) {
                console.error('Error:', error);
            });
            return [2 /*return*/];
        });
    }); };
    var handleSaveConfig = function (slack_notifications, timeoutSeconds) { return __awaiter(void 0, void 0, void 0, function () {
        var newTimeoutId;
        return __generator(this, function (_a) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            newTimeoutId = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    fetch(App.api_base + '/save_config', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Vuedoo-Domain': App.domain,
                            'X-Vuedoo-Access-Key': data.access_key
                        },
                        body: JSON.stringify({ slack_notifications: slack_notifications })
                    })
                        .then(function (response) {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json(); // Parse JSON response
                    })
                        .then(function (res) {
                        if (res.status === 'success') {
                            //do nothing
                            //later show something to let user know that it's saved
                        }
                    })
                        .catch(function (error) {
                        console.error('Error:', error);
                    });
                    return [2 /*return*/];
                });
            }); }, timeoutSeconds);
            setTimeoutId(newTimeoutId);
            return [2 /*return*/];
        });
    }); };
    var checkAndSetDefaultNotification = function (slack_notifications) {
        var n_indices = ['orderUpdates', 'lowStockAlerts', 'outOfStockAlerts', 'dailySummary'];
        var n_messages = {
            orderUpdates: 'You\'ve received a new order. Check your dashboard for details!',
            lowStockAlerts: 'Stock is running low for one or more products. Replenish soon to avoid stockouts.',
            outOfStockAlerts: 'Some products are now out of stock. Take action to restock and notify customers.',
            dailySummary: 'Here\'s your daily summary: Orders received and sales insights.',
            newCustomerSignup: "A new customer has signed up! Welcome them to your store.",
            cartAbandonment: "A customer has left items in their cart without completing the purchase. Follow up to close the sale.",
            orderShipped: "An order has been shipped. Keep your customer informed with tracking details.",
            refundProcessed: "A refund has been processed for an order. Review the details in your dashboard.",
            positiveReview: "You've received a positive review! Celebrate and thank your customer.",
            negativeFeedback: "A customer has left negative feedback. Review it and take action to address their concerns.",
        };
        n_indices.forEach(function (index) {
            // Check if the notification exists
            var notificationExists = slack_notifications.some(function (notification) { return notification.id === index; });
            // If not, add a default notification
            if (!notificationExists) {
                var defaultNotification = {
                    id: index,
                    message: n_messages[index], // Customize message for each index
                    channel: { label: 'Do not notify', value: '' }, // Default Slack channel
                };
                // Add the default notification
                slack_notifications.push(defaultNotification);
            }
        });
        return slack_notifications;
    };
    var handleNotificationChange = function (notificationId, fieldId, value) {
        setData(function (prevData) {
            var updatedNotifications = prevData.slack_notifications.map(function (notif) {
                var _a, _b;
                if (notif.id === notificationId) {
                    if (fieldId == 'message') {
                        return __assign(__assign({}, notif), (_a = {}, _a[fieldId] = value, _a));
                    }
                    else if (fieldId == 'channel') {
                        var selectedChannel = prevData.slack_channels.find(function (channel) { return channel.id === value; });
                        if (selectedChannel == undefined) {
                            selectedChannel = { name: 'Do not notify', id: '', is_channel: true };
                        }
                        if (selectedChannel != undefined) {
                            return __assign(__assign({}, notif), (_b = {}, _b[fieldId] = { label: selectedChannel.name, value: selectedChannel.id }, _b));
                        }
                    }
                }
                return notif;
            });
            //Update in the database
            handleSaveConfig(updatedNotifications, (fieldId == 'channel' ? 0 : 1500));
            return __assign(__assign({}, prevData), { slack_notifications: updatedNotifications });
        });
    };
    var notificationOptionRows = notificationOptions.map(function (option) {
        // Find the corresponding notification from the slack_notifications array
        var notification = data.slack_notifications.find(function (notif) { return notif.id === option.id; });
        // If a matching notification is found, use its message and channel value
        var notification_message = notification ? notification.message : '';
        var channel_value = notification && notification.channel ? notification.channel.value : '';
        return [
            _jsxs(BlockStack, { gap: "200", children: [_jsx(Text, { as: "h2", variant: "bodyMd", fontWeight: "bold", children: option.name }), _jsx(Text, { as: "p", variant: "bodyMd", children: option.description })] }),
            _jsx(TextField, { label: "Custom notification message (Optional)", value: notification_message, multiline: 1, autoComplete: "off", onChange: function (newValue) { return handleNotificationChange(option.id, "message", newValue); } }),
            _jsx(Select, { label: "Select a channel", options: data.slack_channel_options, value: channel_value, onChange: function (newValue) { return handleNotificationChange(option.id, "channel", newValue); } })
        ];
    });
    return data.is_loading ? (_jsx(SkeletonPage, { primaryAction: true, children: _jsx(Layout, { children: _jsxs(Layout.Section, { children: [_jsx(LegacyCard, { sectioned: true, children: _jsx(SkeletonBodyText, {}) }), _jsx(LegacyCard, { sectioned: true, children: _jsxs(TextContainer, { children: [_jsx(SkeletonDisplayText, { size: "small" }), _jsx(SkeletonBodyText, {})] }) }), _jsx(LegacyCard, { sectioned: true, children: _jsxs(TextContainer, { children: [_jsx(SkeletonDisplayText, { size: "small" }), _jsx(SkeletonBodyText, {})] }) })] }) }) })) : (_jsxs(Page, { title: "TW - Quote Requests & Offers", subtitle: "Hide price and let user request a quote, or make an offer on products.", compactTitle: true, children: [_jsxs(BlockStack, { gap: "200", children: [_jsx(Card, { children: _jsxs(BlockStack, { gap: "200", children: [_jsx(Text, { variant: "headingMd", as: "h2", children: "Quick Start: Using Quote & Offer App" }), _jsx(Text, { as: "p", tone: "subdued", children: "This is the simplest possible way to hide a product price and accept quote requests or offers \u2014 with zero learning curve and no extra admin panel." }), _jsxs(Text, { as: "p", tone: "subdued", children: [_jsx("br", {}), _jsx("iframe", { width: "560", height: "315", src: "https://www.youtube.com/embed/sGoEY_FtFGg?si=JqY_P5hpZvKO95F3", title: "YouTube video player", frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", referrerPolicy: "strict-origin-when-cross-origin", allowFullScreen: true })] })] }) }), _jsx(Card, { children: _jsxs(BlockStack, { gap: "200", children: [_jsx(Text, { variant: "headingMd", as: "h2", children: "Step 1: Enable the App Block" }), _jsx(Badge, { tone: "info", children: "Theme Editor" }), _jsxs(List, { type: "number", children: [_jsxs(List.Item, { children: ["Go to ", _jsx("strong", { children: "Online Store \u2192 Customize" }), "."] }), _jsxs(List.Item, { children: ["Open your ", _jsx("strong", { children: "Product template" }), "."] }), _jsxs(List.Item, { children: ["Click ", _jsx("strong", { children: "Add block" }), " and select ", _jsx("strong", { children: "\u201CQuote & Offer\u201D" }), "."] }), _jsx(List.Item, { children: "Drag it into the product form." })] })] }) }), _jsx(Card, { children: _jsxs(BlockStack, { gap: "200", children: [_jsx(Text, { variant: "headingMd", as: "h2", children: "Step 2: Activate Per Product" }), _jsx(Badge, { tone: "info", children: "Product Settings" }), _jsxs(List, { type: "number", children: [_jsx(List.Item, { children: "Open the product where you want quotes or offers." }), _jsxs(List.Item, { children: ["Scroll to the ", _jsx("strong", { children: "Quote & Offer" }), " section."] }), _jsxs(List.Item, { children: ["Select one of the modes:", _jsxs(List, { type: "bullet", children: [_jsxs(List.Item, { children: [_jsx("strong", { children: "Quote Mode" }), " \u2014 hides price & Add to Cart."] }), _jsxs(List.Item, { children: [_jsx("strong", { children: "Offer Mode" }), " \u2014 allows customers to make an offer."] })] })] })] }), _jsx(Text, { as: "p", tone: "subdued", children: "Only enabled products will show the feature. Others remain unchanged." })] }) }), _jsx(Card, { children: _jsxs(BlockStack, { gap: "200", children: [_jsx(Text, { variant: "headingMd", as: "h2", children: "Step 3: Manage Orders Normally" }), _jsx(Badge, { tone: "info", children: "Draft Orders" }), _jsxs(Text, { as: "p", children: ["All submissions go directly into your ", _jsx("strong", { children: "Shopify Draft Orders" }), " list. No separate dashboards or logins are required."] })] }) }), _jsx(Card, { children: _jsxs(Text, { as: "p", tone: "subdued", children: ["\u2705 No third-party admin panels", _jsx("br", {}), "\u2705 No extra apps or setup", _jsx("br", {}), "\u2705 Works only where you enable it"] }) })] }), _jsxs(FooterHelp, { children: [_jsx(Link, { url: "https://docs.google.com/forms/d/e/1FAIpQLSeDowjHbxsR7KNpvYgVLOXY4CvvAb8-_85SQ5aHFmlNZ0A3Ew/viewform?pli=1", target: "_blank", children: "Click this link" }), ' ', "to share your feedback or submit a feature request."] })] }));
};
export default Dashboard;
